import axios from 'axios'

export default {
  getClientProfile(id) {
    return axios.get(`/profile/${id}`)
  },
  // editUser(id, payload) {
  //   return axios.patch(`/users/${id}`, payload)
  // },
  // saveUser(payload) {
  //   return axios.post('/users/', payload)
  // },
  // deleteUser(id) {
  //   return axios.delete(`/users/${id}`)
  // }
}
